import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import HomeCardsContainer from "./HomeCardsContainer"
// import DSA from "../categories/DSA"
import BackgroundImage from "gatsby-background-image"

function Home() {
  const data = useStaticQuery(graphql`
    {
      img: file(relativePath: { eq: "bg/bg3.jpg" }) {
        id
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <section>
      <BackgroundImage
        className="homeContainer"
        fluid={data.img.childImageSharp.fluid}
      >
        <h1 className="text-white text-center">No Stack to Fullstack</h1>
        <h5 className="text-info">A programming blog</h5>
      </BackgroundImage>
      <HomeCardsContainer />
      {/* <DSA show={true} /> */}
    </section>
  )
}

export default Home
